var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { HDSPagination } from "@here/hds-react-components/Pagination";
import "./styles.scss";
export var Pagination = function (props) {
    var onChange = props.onChange, otherProps = __rest(props, ["onChange"]);
    var handleChange = function (e) {
        onChange && onChange(e);
    };
    return (_jsx("div", __assign({ className: "paginationWrapper" }, { children: _jsx(HDSPagination, __assign({ "data-cy": "pagination-element", onChange: handleChange, textAfterPage: "of {totalPages}", textBeforeItemsPerPage: "Items per page:", textBeforePage: "Page:", itemsPerPageValues: "[15,30,45,60]" }, otherProps)) })));
};
